import { TDonutDatum } from './types'

/**
 * Constant representing placeholder data that will force the donut to render
 * as a single section, used when rendering an "empty" state.
 */
export const FAKE_NO_DATA: TDonutDatum[] = [{ label: 'no data', value: 1 }]
